import { useState } from 'react';
import { formatPeso, type ExpenseFields } from '@tahi/core';
import { addExpense, deleteExpense } from '../../../data/commands/spending';
import { useMethodOptions } from '../../../data/methodOptions';
import { useCommandEnv, useUsable } from '../../../data/hooks';
import { showToast } from '../../../ui';
import { SpendPickers } from '../../budget/components/SpendPickers';
import { useBudgetSettings } from '../../budget/hooks';
import { QuickAddForm } from '../QuickAddForm';
import { copy, errorText } from '../copy';
import { useCategories, useGoBack, useNoteHistory, useToday } from '../hooks';

export function QuickAddRoute() {
  const env = useCommandEnv();
  const goBack = useGoBack();
  const methods = useMethodOptions();
  const today = useToday();
  const categories = useCategories() ?? [];
  const noteHistory = useNoteHistory() ?? [];
  const usable = useUsable();
  const settings = useBudgetSettings();
  const [fundId, setFundId] = useState<string | null>(null);
  const [accountId, setAccountId] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const budget = usable('budget');

  async function onSubmit(fields: ExpenseFields) {
    const r = await addExpense(env, {
      ...fields,
      // v0.5: a limit only while spending limits are on; the "From" account (default if none).
      fundId: budget && settings?.useFunds ? fundId : null,
      accountId: budget ? accountId : null,
    });
    if (!r.ok) {
      setError(errorText(r.error));
      return;
    }
    showToast({
      message: copy.added(formatPeso(fields.amountMinor)),
      action: { label: copy.undo, onPress: () => void deleteExpense(env, r.id) },
    });
    goBack();
  }

  return (
    <QuickAddForm
      methods={methods}
      mode="add"
      title={copy.quickAddTitle}
      onClose={goBack}
      today={today}
      categories={categories}
      noteHistory={noteHistory}
      error={error}
      onSubmit={onSubmit}
      // v0.7.6: cards are picked under "From", next to the accounts, while Budget is on.
      cardsInFrom={budget}
      extra={
        budget
          ? ({ date, method, setMethod }) => (
              <SpendPickers
                fundId={fundId}
                onFund={setFundId}
                accountId={accountId}
                onAccount={setAccountId}
                card={{ method, onMethod: setMethod, date }}
              />
            )
          : undefined
      }
    />
  );
}
